/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { GenericApi } from '../api/generic.api';
import { switchMap, map } from 'rxjs/operators';
import { GenericData, Generic } from '../../../interfaces/masters/generic';

@Injectable()
export class GenericService extends GenericData {

  constructor(private api: GenericApi) {
    super();
  }


  list(): Observable<Generic[]> {
    return this.api.list();
  }

  genericListSearch(searchWord:string): Observable<Generic[]> {
    return this.api.genericListSearch(searchWord);
  }

  getById(url:string): Observable<Generic>{
      return this.api.getById(url);
  }

  create(url: string, data:Generic): Observable<Generic> {
    return this.api.add(url,data);
  }

  update(url: string, data:Generic): Observable<Generic> {
    return this.api.update(url,data);
  }
searchList(url: string,data:any): Observable<any> {
      debugger;
      return this.api.searchList(url,data);
    }
  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
  //uploadData
  
  postData(url: string, data:any[]): Observable<Generic> {
    return this.api.addData(url,data);
  }
}
